import type { Control } from 'react-hook-form';
import { Controller } from 'react-hook-form';

import type { SearchProps } from 'components/shared/Search';
import Search from '../Search/Search';
import { AutocompleteChangeReason } from '@mui/material';

type Props<T> = SearchProps<T> & {
  control: Control<any>;
  name: string;
  showOptionsOnFocus?: boolean;
  value?: T | null;
  onChange?: (selectedOption: T) => void;
};

export default function ControlledSearch<T>({
  control,
  name,
  value,
  onChange,
  noOptionsText,
  showOptionsOnFocus,
  ...props
}: Props<T>) {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => (
        <Search
          value={value}
          error={!!fieldState?.error?.type}
          helperText={fieldState?.error?.message}
          noOptionsText={noOptionsText}
          showOptionsOnFocus={showOptionsOnFocus}
          ref={field.ref}
          {...props}
          onSelected={(
            selectedOption?: T | null,
            reason?: AutocompleteChangeReason
          ) => {
            field.onChange(selectedOption);
            field.value = selectedOption;
            props.onSelected?.(selectedOption, reason);
            selectedOption && onChange?.(selectedOption);
          }}
        />
      )}
    />
  );
}
